var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.891 13.481H9.109C7.95 13.481 7 14.431 7 15.59v10.241c0 1.159.95 2.109 2.109 2.109h14.782c1.159 0 2.109-.95 2.109-2.109V15.59c0-1.159-.95-2.109-2.109-2.109v0ZM11.238 13.481V9.263c0-1.406.551-2.736 1.54-3.724a5.28 5.28 0 0 1 7.447 0 5.28 5.28 0 0 1 1.54 3.724v4.218M13.174 20.72h6.669",
    stroke: "#85BB65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLock;